// @flow
import styled, {css} from "styled-components";
import {FloatingContainer, VerticalDelimeter} from "../../../../AppStyle";
import {RideAcceptedContentContainer} from "../RideAcceptedStyle";
import {styles} from "../../../../../config";

export const RideAcceptedBottomContainer = styled.div`
    ${FloatingContainer};
    position: absolute;
    bottom: 15px;
    background-color: rgb(255, 255, 255);
    box-shadow: 0px 0px 15px 0 #00000026;
    padding: 0;
    text-align: center;RideAcceptedBottom
    line-height: 30px;
    vertical-align: middle;
    // display: flex;
`;

export const RideAcceptedBottomTitleContainer = styled.label`
    width: 100%;
    justify-content: start;
    background-color: ${styles.primaryColor};
    height: 22px;
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    display: flex;
`;

export const RideAcceptedBottomTitle = styled.div`
    color: #ffffff;
    font-size: 11.5px;
    line-height: 1.9;
    margin-left: 6px;
    margin-right: 6px;
`;

export const RideAcceptedBottomInfoRow = styled.div`
    display: table;
    width: 100%;
    // padding-left: 16px;
    // padding-right: 16px;
`;

export const RideAcceptedCarIcon = styled.img`
    width: 56px;
    height: 56px;
`;

export const RideAcceptedInfoLabel = css`
    margin-left: 4px;
    margin-right: 4px;
    margin-bottom: 0;
`;

export const RideAcceptedVanPlate = styled.label`
    ${RideAcceptedInfoLabel};
    font-weight: 600;
    font-size: 17px;
    color: #545454;
`;

export const RideAcceptedVanInfo = styled.label`
    ${RideAcceptedInfoLabel};
    font-weight: 300;
    font-size: 15.4px;
    line-height: 15.4px;
    color: #555555;
`;

export const RideAcceptedVanLabels = RideAcceptedContentContainer.extend`
    text-align: start;
    line-height: 17px;
`;

export const RideAcceptedVerticalDelimeter = styled.div`
    ${VerticalDelimeter}
    background-color: #e6e6e6;
    min-width: 2px;
    max-width: 2px;
    min-height: 80px;
    max-height: 120px;
`;

export const RideAcceptedDriverImageContainer = styled.div`
    margin-top: 15px;
    margin-left: 0;
    margin-right: 0;
    position: relative;
`;

export const RideAcceptedDriverPhoto = styled.img`
    width: 61px;
    height: 61px;
    position: inherit;
    vertical-align: bottom;
`;

export const RideAcceptedCallDriver = styled.img`
    vertical-align: bottom;
    position: absolute;
    left: 50%;
    right: 50%;
    top: 46%;
`;

export const RideAcceptedDriverName = styled.label`
    margin-top: 0;
    margin-bottom: 8px;
    font-size: 15.4px;
    color: #545454;
    font-weight: 400;
    line-height: 30px;
`;



// WEBPACK FOOTER //
// ./src/Components/Screen/Ride/RideAccepted/RideAcceptedBottom/RideAcceptedBottomStyle.js